import axios from 'axios';
import { commonConfiguration } from 'io/API';
import { onRequestError } from 'io/API/errorHandling';
import { getCookie } from 'utils/cookies';


const patchFilterPreference = (filterPreferenceID, changes, contextConfiguration) => {
	const token = getCookie('authToken');
	return axios.patch(
		filterPreferenceID ? `/zoekopdrachten/${filterPreferenceID}` : '/zoekopdrachten',
		changes,
		{
			...commonConfiguration,
			...contextConfiguration,
			headers: {
				Authorization: token ? `Token ${token}` : undefined,
				'X-Requested-With': 'XMLHttpRequest',
			}
		}
	).catch(onRequestError);
};

export default patchFilterPreference;
